// Official YouTube channels surfaced on the Events 360 page.
//
// The channel IDs below were resolved from the official Lagos State agency pages
// and verified to return live feed data. To add a channel, drop its
// /channel/UC... ID in here — no other change is needed.
//
// A YouTube Data API key is not required. Live-stream detection is not
// implemented because the public RSS feed does not carry live status and there
// is no keyless endpoint that exposes it.
export const SOCIAL_CHANNELS = [
  {
    id: "UCp_zSjU59H3031LwJcIFN8w",
    name: "Lagos Television",
    handle: "Lagos TV",
  },
  {
    id: "UC_-39zfDjfiPb7zQI1ZKd6A",
    name: "Lagos Transport Authority",
    handle: "LTA TV",
  },
  {
    id: "UCBkBVfrX8G8FpiIutbJOecg",
    name: "Lagos State Parking Authority",
    handle: "LASPA",
  },
  {
    id: "UCtv6a3K7TfF7NS-9p8zqWWQ",
    name: "Local Government Establishments & Training",
    handle: "OLGE&T",
  },
];